import { utils } from '@americanexpress/axp-field-validations-germany';
// import { getDuration } from '../../DataConversion/getDuration';
import { industryOptions, occupationOptions, professionOptions } from '../financialOptions';
import { prefixOptions, titleOptions } from '../../components/FieldOptions/nameOptions';

const countryOptions = Object.entries(utils.countryNameCodes).map(([label, value]) => [{
  label,
  value,
}][0]);

/**
 * Update the boolean value to Yes or No
 * @param {boolean} value
 * @returns {string}
 */
export const updateBooleanValue = (value) => {
  if (value === true) return 'Ja';
  if (value === false) return 'Nein';
  return value;
};

/**
 * Get the label of the value from the options array
 * @param {string} value
 * @param {Array} options
 * @returns {string}
 */
export const getLabelOfValue = (value, options) => {
  if (!value || !options) return '';
  const selectedOption = options.find((option) => option.value === value);
  return selectedOption ? selectedOption.label : '';
};

export const updateSubmitedValues = (values) => {
  const {
    prefix,
    title,
    nationality,
    profession,
    industry,
    occupation,
  } = values;

  return {
    ...values,
    prefix: getLabelOfValue(prefix, prefixOptions),
    title: getLabelOfValue(title, titleOptions),
    profession: getLabelOfValue(profession, professionOptions),
    industry: getLabelOfValue(industry, industryOptions),
    occupation: getLabelOfValue(occupation, occupationOptions[industry]),
    nationality: getLabelOfValue(nationality, countryOptions),
  };
};
